export default "__VITE_ASSET__BmCJqerl__"